import { Role, rolesManipulator } from 'auth';
import { useCallback, useContext } from 'react';
import LinkedTaskItem from '@/modules/common/components/items/LinkedTaskItem.tsx';
import { useTasksListByLinkedIncidentQuery } from '@/modules/common/queries/tasks.ts';
import { CreateTaskModal } from '@/modules/admin-dashboard/components/modals/CreateTaskModal.tsx';
import { Button, EmptyListState, ModalProviderContext, Spinner, TooltipNew } from 'ui';
import { IncidentResultSchemaWithRel, IncidentResultStatus } from 'compliance-api';

interface LinkedTasksProps {
  incident: IncidentResultSchemaWithRel;
  onCloseModal: () => void;
}

const LinkedTasks = ({ incident, onCloseModal }: LinkedTasksProps) => {
  const isUserAdmin = rolesManipulator.current_user_role === Role.COMPLIANCE_ADMIN;
  const { openModal } = useContext(ModalProviderContext);

  const { data, isLoading } = useTasksListByLinkedIncidentQuery(incident.id);

  const tasks = data?.tasks || [];

  const handleOpenCreateTaskModal = useCallback(() => {
    openModal(CreateTaskModal, {
      defaultIncident: { label: incident.name, value: { id: incident.id } },
    });
    onCloseModal();
  }, [incident.id, incident.name, onCloseModal, openModal]);
  return (
    <div className="space-y-4 px-2 sm:px-8 py-4">
      {isUserAdmin && (
        <TooltipNew
          disabled={incident.status !== IncidentResultStatus.Resolved}
          text="It is not possible to add a task for resolved events"
        >
          <Button
            onClick={handleOpenCreateTaskModal}
            loading={isLoading}
            disabled={isLoading || incident.status === IncidentResultStatus.Resolved}
          >
            Add task
          </Button>
        </TooltipNew>
      )}

      {isLoading && <Spinner size="lg" className="m-auto" />}
      <EmptyListState
        title="No linked tasks for this incident yet"
        description={''}
        isLoading={isLoading}
        isSearchUsed={false}
        itemsCount={tasks.length}
        classes={{ title: '!text-2xl', image: '!w-[70px] !h-[70px] [&>img]:w-8' }}
      />
      {!isLoading && !!tasks.length && (
        <div className="flex flex-col gap-4">
          {tasks.map(task => (
            <LinkedTaskItem key={task.id} task={task} />
          ))}
        </div>
      )}
    </div>
  );
};

export default LinkedTasks;
